import { T_OFFLINE_OVERLAY_PAGE_CONSTANTS } from './TYPES'

const HU_OFFLINE_OVERLAY_PAGE_CONSTANTS: T_OFFLINE_OVERLAY_PAGE_CONSTANTS = {
  OFFLINE_TITLE: 'Nincs internetkapcsolat',
  OFFLINE_DESCRIPTION:
    'Kérlek, ellenőrizd az internetkapcsolatodat az alkalmazás folytatásához.'
}

export default HU_OFFLINE_OVERLAY_PAGE_CONSTANTS
